'use client';

import { useEffect } from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

/**
 * Глобальный error-boundary — перехватывает ошибки на верхнем уровне,
 * когда корневой layout не может отрендериться
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Глобальная ошибка:', error);
  }, [error]);

  return (
    <html lang="ru">
      <body
        style={{
          backgroundColor: '#0f1115',
          color: '#f0f0f0',
          fontFamily: 'system-ui, -apple-system, sans-serif',
          margin: 0,
          padding: 0,
        }}
      >
        <div
          style={{
            display: 'flex',
            minHeight: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1.5rem',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '1.5rem',
              textAlign: 'center',
              maxWidth: '28rem',
            }}
          >
            <AlertCircle size={48} color="#f87171" />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <h2 style={{ fontSize: '1.25rem', fontWeight: 600, margin: 0 }}>
                Критическая ошибка
              </h2>
              <p style={{ fontSize: '0.875rem', color: '#8b8b8b', margin: 0 }}>
                {error.message || 'Произошла непредвиденная ошибка.'}
              </p>
            </div>
            <button
              onClick={reset}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 1rem',
                borderRadius: '0.375rem',
                border: '1px solid #25282e',
                backgroundColor: 'transparent',
                color: '#f0f0f0',
                fontSize: '0.875rem',
                cursor: 'pointer',
              }}
            >
              <RefreshCw size={16} />
              Попробовать снова
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
